import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonService } from '@src/app/services/common.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { Column } from '@src/app/shared/types/ss-table.type'; // 添加类型导入
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTableModule } from 'ng-zorro-antd/table';

@Component({
    selector: 'app-socialscan-table-thead-th',
    standalone: true,
    imports: [CommonModule, SharedModule, NzTableModule, NzDropDownModule, FormsModule],
    templateUrl: './socialscan-table-thead-th.component.html',
    styleUrls: ['./socialscan-table-thead-th.component.less'],
})
export class SocialscanTableTheadThComponent implements OnInit, OnChanges {
    @Input() column: Column;
    @Output() sortChange = new EventEmitter<Column>();
    @Output() filterChange = new EventEmitter<{ column: Column; value: any }>();

    filterData: any = null;
    selectedColumn: Column;

    constructor(private commonService: CommonService, private walletStatusService: WalletStatusService) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['column'] && this.column) {
            this.filterData = this.column.filterData;
            this.selectedColumn = this.column;
        }
    }

    ngOnInit() {
        this.selectedColumn = this.column;
        this.initializeFilterData();
    }

    customSortChange(column: Column) {
        this.sortChange.emit(column);
    }

    filterVisibleChange(column: Column) {
        this.selectedColumn = column;
        this.initializeFilterData();
    }

    isFilterActive(column: Column) {
        if (!column.showFilter) return false;

        if (column.filterType === 'numberRange') {
            return column.filterData?.[0] !== null || column.filterData?.[1] !== null;
        }
        return column.filterData !== null;
    }

    applyQuickOption(option: { name: string; value: any }) {
        this.filterData = option.value;
    }

    reset() {
        if (this.selectedColumn.filterType === 'numberRange') {
            this.filterData = [null, null];
        } else {
            this.filterData = null;
        }

        this.applyFilter();
    }

    applyFilter() {
        if (!this.walletStatusService.isWalletConnected) {
            this.commonService.showLogInModal();

            return;
        }

        this.selectedColumn.filterData = this.filterData;
        this.filterChange.emit({ column: this.selectedColumn, value: this.filterData });
        // 模拟点击 body 关闭 filter，使用visible 控制会有位置问题
        document.body.click();
    }

    private initializeFilterData() {
        if (!this.selectedColumn) return;

        // 如果已有filterData，使用现有的值
        if (this.selectedColumn.filterData) {
            this.filterData = this.selectedColumn.filterData;
            return;
        }

        // 否则设置默认值
        if (this.selectedColumn.filterType === 'numberRange') {
            this.filterData = [null, null];
        } else {
            this.filterData = null;
        }
    }
}
